import * as React from 'react';
import { Modal } from '../../../../Modal';
import { TaxDeduction } from "../../../../TaxDeduction";
import * as main from "../../styles/main.module.scss";
import * as cost from "./style.module.scss"

export const Cost = ({ widget, free=false, accessLimited }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className={`${cost.cost} ${main.sec}`}>
      <div className={cost.cost_bg}>
        <div className="container">
          <div className={`row ${cost.cost_row}`}>
            <div className={`col col-12 ${cost.col_cost}`}>
              <div className={cost.col_costWrapper} id={"cost"}>
                <div className={cost.col_costWrapperTitle}>
                  Онлайн-курс
                </div>
                <div className={cost.col_costWrapperSubtitle}>
                  Глобус на&nbsp;пальце
                </div>

                <div className={cost.oldcost}>15&nbsp;000</div>

                <div className={cost.newcost}>
                  {
                    free ?
                      "БЕСПЛАТНО"
                      :
                      "8\u00A0900"
                  }
                </div>

                <div className={main.btnBlock}>
                  <button className={main.mainBtn} onClick={()=>{setShowModal(true)}}>
                    Оставить заявку
                  </button>
                </div>

                {
                  !free && <TaxDeduction margin={"40px 0 0"}/>
                }
                { accessLimited && <p style={{ margin: "40px 0 0", textAlign: "center" }}>Бесплатный доступ действителен в&nbsp;течение 7&nbsp;дней</p> }
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </section>
  );
};
